const APP_RSVP_SCHEME = 'com.app.citizex://events/';
/** Offer this only after the guest explicitly taps RSVP. A timer cannot tell
 * whether an iOS open-app prompt is still on screen, so web remains a choice.
 */
export function getAppRsvpUrl(eventId: number, document: Document): string | null {
  const navigator = document.defaultView?.navigator;
  const isMobile =
    navigator &&
    (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
  return isMobile && Number.isSafeInteger(eventId) && eventId > 0
    ? `${APP_RSVP_SCHEME}${eventId}?intent=rsvp`
    : null;
}
